import { CustomerCategoryEnum, PetsEnum, RecurrenceEnum } from "../Lead.model";

const projectTypeOptions = [
  { label: "Post Construction", value: "POST_CONSTRUCTION" },
  { label: "Move out", value: "MOVE_OUT" },
  { label: "Move in", value: "MOVE_IN" },
  { label: "Floor Care", value: "FLOOR_CARE" },
  { label: "Apartment Turnover", value: "APPARTMENT_TURNOVER" },
  { label: "Window Cleaning", value: "WINDOW_CLEANING" },
  { label: "Recurring Residential", value: "RECURRING_RESIDENTIAL" },
  { label: "Recurring Commercial", value: "RECURRING_COMMERCIAL" },
  { label: "Electrostatic Disinfection", value: "ELECTROSTATIC_DISINFECTION" },
  { label: "Special Services", value: "SPECIAL_SERVICES" },
];

const customerCategoryOptions = [
  {
    label: "Corporate",
    value: CustomerCategoryEnum.CORPORATE,
  },
  {
    label: "Individual",
    value: CustomerCategoryEnum.INDIVIDUAL,
  },
];

const recurrenceOptions = [
  {
    label: "Yes",
    value: RecurrenceEnum.Y,
  },
  {
    label: "No",
    value: RecurrenceEnum.N,
  },
  {
    label: "Not Applicable",
    value: RecurrenceEnum.NA,
  },
];

const petsOptions = [
  {
    label: "Yes",
    value: PetsEnum.Y,
  },
  {
    label: "No",
    value: PetsEnum.N,
  },
  {
    label: "Not Applicable",
    value: PetsEnum.NA,
  },
];

export {
  projectTypeOptions,
  customerCategoryOptions,
  recurrenceOptions,
  petsOptions,
};
